import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
var Rank1 = function Rank1(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_365)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_365)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_365",
        x: "-11",
        y: "0.94397",
        width: "80",
        height: "100.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_365"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_365",
          result: "effect2_dropShadow_1_365"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_365",
          result: "effect3_dropShadow_1_365"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_365",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_365",
        x: "16.8081",
        y: "17.944",
        width: "34.9778",
        height: "66.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_365"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_365",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank1.defaultProps = {
  width: "68",
  height: "101",
  viewBox: "0 0 68 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank2 = function Rank2(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_367)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_367)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M56.228 76H20.476C21.0227 73.376 21.788 70.9707 22.772 68.784C23.756 66.5427 24.986 64.4107 26.462 62.388C27.938 60.3653 29.66 58.3973 31.628 56.484C33.6507 54.516 35.9467 52.548 38.516 50.58L44.174 46.152C45.7047 44.9493 46.962 43.8833 47.946 42.954C48.9847 41.97 49.8047 40.986 50.406 40.002C51.062 39.018 51.5813 37.9793 51.964 36.886C52.3467 35.738 52.702 34.3987 53.03 32.868C53.1393 32.376 53.2213 31.9113 53.276 31.474C53.3307 31.0367 53.358 30.5993 53.358 30.162C53.358 27.1553 51.8273 25.652 48.766 25.652C47.29 25.652 46.06 25.9527 45.076 26.554C44.092 27.1553 43.272 27.9753 42.616 29.014C41.96 30.0527 41.4133 31.2553 40.976 32.622C40.5387 33.9887 40.156 35.4373 39.828 36.968H28.512L29.004 34.754C30.2067 29.342 32.5027 25.1873 35.892 22.29C39.336 19.3927 44.2287 17.944 50.57 17.944C55.5447 17.944 59.2073 18.928 61.558 20.896C63.9633 22.8093 65.166 25.5973 65.166 29.26C65.166 31.6653 64.8927 33.9067 64.346 35.984C63.7993 38.0067 62.952 39.9473 61.804 41.806C60.656 43.6647 59.2347 45.4413 57.54 47.136C55.9 48.8307 53.9867 50.5253 51.8 52.22L43.928 58.288C41.8507 59.8733 40.156 61.4313 38.844 62.962C37.5867 64.438 36.712 65.7227 36.22 66.816H58.114L56.228 76Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_367",
        x: "-1",
        y: "0.94397",
        width: "86.166",
        height: "100.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_367"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_367",
          result: "effect2_dropShadow_1_367"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_367",
          result: "effect3_dropShadow_1_367"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_367",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_367",
        x: "16.4761",
        y: "17.944",
        width: "52.6899",
        height: "66.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_367"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_367",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank2.defaultProps = {
  width: "86",
  height: "101",
  viewBox: "0 0 86 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank3 = function Rank3(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_369)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_369)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M32.482 59.026C32.0447 61.2127 31.826 62.962 31.826 64.274C31.826 66.0233 32.1813 67.3353 32.892 68.21C33.6573 69.03 34.942 69.44 36.746 69.44C38.386 69.44 39.78 69.0573 40.928 68.292C42.076 67.472 42.978 66.4333 43.634 65.176C44.3447 63.864 44.864 62.4153 45.192 60.83C45.52 59.2447 45.684 57.632 45.684 55.992C45.684 54.2973 45.2467 52.9033 44.372 51.81C43.552 50.7167 41.9667 50.17 39.616 50.17H35.68L37.32 42.462H41.174C42.65 42.462 43.9347 42.0793 45.028 41.314C46.176 40.5487 47.1327 39.5647 47.898 38.362C48.6633 37.1047 49.2373 35.7653 49.62 34.344C50.0027 32.868 50.194 31.4193 50.194 29.998C50.194 28.4127 49.8113 27.292 49.046 26.636C48.2807 25.98 47.16 25.652 45.684 25.652C44.4267 25.652 43.3607 25.898 42.486 26.39C41.6113 26.8273 40.846 27.4833 40.19 28.358C39.5887 29.178 39.0967 30.162 38.714 31.31C38.3313 32.458 38.0033 33.7153 37.73 35.082H26.906C28.1087 29.2873 30.432 24.996 33.876 22.208C37.3747 19.3653 41.9393 17.944 47.57 17.944C52.1073 17.944 55.5787 18.8187 57.984 20.568C60.3893 22.3173 61.592 25.0507 61.592 28.768C61.592 31.064 61.264 33.1687 60.608 35.082C60.0067 36.9953 59.1593 38.69 58.066 40.166C57.0273 41.5873 55.77 42.79 54.294 43.774C52.818 44.7033 51.26 45.332 49.62 45.66V45.824C52.4627 46.316 54.4853 47.382 55.688 49.022C56.9453 50.6073 57.574 52.63 57.574 55.09C57.574 57.058 57.246 59.3267 56.59 61.896C55.934 64.4653 54.7313 66.8707 52.982 69.112C51.2873 71.3533 48.9093 73.2667 45.848 74.852C42.8413 76.3827 38.96 77.148 34.204 77.148C29.5573 77.148 26.086 76.082 23.79 73.95C21.5487 71.7633 20.428 68.702 20.428 64.766C20.428 63.1807 20.6467 61.3493 21.084 59.272L21.166 59.026H32.482Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_369",
        x: "-4",
        y: "0.94397",
        width: "85.592",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_369"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_369",
          result: "effect2_dropShadow_1_369"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_369",
          result: "effect3_dropShadow_1_369"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_369",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_369",
        x: "16.428",
        y: "17.944",
        width: "49.1641",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_369"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_369",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank3.defaultProps = {
  width: "82",
  height: "103",
  viewBox: "0 0 82 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank4 = function Rank4(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_371)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_371)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M22.658 54.27L49.472 17.944H61.69L53.982 54.762H59.558L57.672 63.946H52.096L49.636 76H38.812L41.272 63.946H20.608L22.658 54.27ZM47.75 32.704H47.586L31.678 54.762H43.158L47.75 32.704Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_371",
        x: "-3",
        y: "0.94397",
        width: "84.6899",
        height: "100.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_371"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_371",
          result: "effect2_dropShadow_1_371"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_371",
          result: "effect3_dropShadow_1_371"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_371",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_371",
        x: "16.6079",
        y: "17.944",
        width: "49.082",
        height: "66.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_371"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_371",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank4.defaultProps = {
  width: "82",
  height: "101",
  viewBox: "0 0 82 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank5 = function Rank5(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_373)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_373)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M60.772 26.276H39.37L35.352 39.478H35.516C36.9373 37.9473 38.5773 36.854 40.436 36.198C42.3493 35.4873 44.5633 35.132 47.078 35.132C49.1553 35.132 50.9047 35.46 52.326 36.116C53.7473 36.7173 54.868 37.5647 55.688 38.658C56.5627 39.6967 57.1913 40.9267 57.574 42.348C57.9567 43.7693 58.148 45.3 58.148 46.94C58.148 49.1267 57.902 51.368 57.41 53.664C56.754 56.8893 55.8793 59.814 54.786 62.438C53.6927 65.062 52.244 67.3307 50.44 69.244C48.6907 71.1027 46.504 72.5513 43.88 73.59C41.256 74.6287 38.0853 75.148 34.368 75.148C31.6347 75.148 29.3387 74.82 27.48 74.164C25.676 73.5627 24.2273 72.77 23.134 71.786C22.0407 70.7473 21.248 69.5993 20.756 68.342C20.3187 67.03 20.1 65.6907 20.1 64.324C20.0453 63.3947 20.0727 62.4927 20.182 61.618C20.346 60.6887 20.4827 59.814 20.592 58.994L20.838 57.436H32.154C32.0447 58.092 31.9353 58.7753 31.826 59.486C31.7167 60.1967 31.662 60.9347 31.662 61.7C31.662 63.1213 31.9353 64.3513 32.482 65.39C33.0833 66.4287 34.2313 66.948 35.926 66.948C38.386 66.948 40.354 66.0187 41.83 64.16C43.306 62.2467 44.4267 59.404 45.192 55.632C45.4653 54.156 45.684 52.844 45.848 51.696C46.012 50.4933 46.094 49.4547 46.094 48.58C46.094 46.612 45.684 45.2453 44.864 44.48C44.044 43.7147 42.732 43.332 40.928 43.332C39.2333 43.332 37.8393 43.824 36.746 44.808C35.6527 45.7373 34.8327 47.022 34.286 48.662H23.708L32.4 17.092H62.658L60.772 26.276Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_373",
        x: "-4",
        y: "0.092041",
        width: "86.658",
        height: "100.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_373"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_373",
          result: "effect2_dropShadow_1_373"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_373",
          result: "effect3_dropShadow_1_373"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_373",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_373",
        x: "16.0181",
        y: "17.092",
        width: "50.6399",
        height: "66.0559",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_373"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_373",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank5.defaultProps = {
  width: "83",
  height: "101",
  viewBox: "0 0 83 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank6 = function Rank6(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_375)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_375)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M33.22 57.96C32.728 60.256 32.482 62.2787 32.482 64.028C32.482 65.668 32.81 66.98 33.466 67.964C34.1767 68.948 35.4613 69.44 37.32 69.44C38.7413 69.44 39.944 69.1667 40.928 68.62C41.912 68.0187 42.732 67.1987 43.388 66.16C44.044 65.1213 44.5633 63.9187 44.946 62.552C45.3833 61.1307 45.766 59.6 46.094 57.96C46.3127 56.8667 46.4767 55.8553 46.586 54.926C46.75 53.9967 46.832 53.1493 46.832 52.384C46.832 50.4707 46.422 49.104 45.602 48.284C44.8367 47.4093 43.634 46.972 41.994 46.972C39.6433 46.972 37.7847 47.8193 36.418 49.514C35.106 51.2087 34.04 54.024 33.22 57.96ZM50.44 32.704C50.5493 32.1573 50.6313 31.638 50.686 31.146C50.7407 30.654 50.768 30.1893 50.768 29.752C50.768 28.3853 50.44 27.374 49.784 26.718C49.128 26.0073 48.062 25.652 46.586 25.652C45.0007 25.652 43.6613 26.0347 42.568 26.8C41.4747 27.5107 40.5453 28.522 39.78 29.834C39.0147 31.146 38.3587 32.704 37.812 34.508C37.2653 36.312 36.7733 38.28 36.336 40.412L35.68 43.282H35.844C37.156 41.7513 38.8233 40.5487 40.846 39.674C42.8687 38.7447 45.192 38.28 47.816 38.28C51.8067 38.28 54.6493 39.346 56.344 41.478C58.0933 43.5553 58.968 46.3433 58.968 49.842C58.968 51.9193 58.722 54.106 58.23 56.402C56.8633 63.1807 54.3213 68.3467 50.604 71.9C46.9413 75.3987 41.8027 77.148 35.188 77.148C32.4 77.148 30.0767 76.7653 28.218 76C26.414 75.2893 24.9653 74.3053 23.872 73.048C22.7787 71.736 21.986 70.2053 21.494 68.456C21.0567 66.652 20.838 64.7113 20.838 62.634C20.838 60.7207 20.9747 58.698 21.248 56.566C21.576 54.434 21.986 52.2473 22.478 50.006C23.3527 45.906 24.3093 41.9427 25.348 38.116C26.3867 34.2347 27.8353 30.818 29.694 27.866C31.5527 24.8593 33.9853 22.454 36.992 20.65C39.9987 18.846 43.9073 17.944 48.718 17.944C50.522 17.944 52.244 18.1353 53.884 18.518C55.524 18.9007 56.9453 19.5293 58.148 20.404C59.4053 21.224 60.3893 22.3173 61.1 23.684C61.8107 25.0507 62.166 26.7453 62.166 28.768C62.166 29.8613 62.0293 31.1733 61.756 32.704H50.44Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_375",
        x: "-4",
        y: "0.94397",
        width: "86.166",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_375"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_375",
          result: "effect2_dropShadow_1_375"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_375",
          result: "effect3_dropShadow_1_375"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_375",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_375",
        x: "16.8379",
        y: "17.944",
        width: "49.3281",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_375"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_375",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank6.defaultProps = {
  width: "83",
  height: "103",
  viewBox: "0 0 83 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank7 = function Rank7(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_377)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_377)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M61.364 17.092L59.478 26.112C56.362 29.5013 53.4373 33.1367 50.704 37.018C48.0253 40.8993 45.538 44.89 43.242 48.99C41.0007 53.09 38.978 57.272 37.174 61.536C35.37 65.7453 33.812 69.9 32.5 74H20.118C21.266 70.5013 22.66 66.8387 24.3 63.012C25.9947 59.1307 27.99 55.1947 30.286 51.204C32.582 47.1587 35.1787 43.1407 38.076 39.15C41.028 35.1047 44.308 31.1413 47.916 27.26H23.48L25.612 17.092H61.364Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_377",
        x: "-8",
        y: "0.092041",
        width: "89.364",
        height: "98.908",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_377"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_377",
          result: "effect2_dropShadow_1_377"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_377",
          result: "effect3_dropShadow_1_377"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_377",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_377",
        x: "16.1179",
        y: "17.092",
        width: "49.2461",
        height: "64.908",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_377"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_377",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank7.defaultProps = {
  width: "82",
  height: "99",
  viewBox: "0 0 82 99",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank8 = function Rank8(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_379)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_379)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M32.318 59.436C31.99 61.0213 31.826 62.4427 31.826 63.7C31.826 65.4493 32.2087 66.8433 32.974 67.882C33.7393 68.9207 35.0787 69.44 36.992 69.44C38.5227 69.44 39.862 69.03 41.01 68.21C42.2127 67.39 43.1967 66.324 43.962 65.012C44.7273 63.6453 45.3013 62.1147 45.684 60.42C46.1213 58.6707 46.34 56.894 46.34 55.09C46.34 53.3953 45.9573 52.0287 45.192 50.99C44.4267 49.9513 43.0873 49.432 41.174 49.432C39.8073 49.432 38.632 49.7053 37.648 50.252C36.7187 50.744 35.8987 51.4547 35.188 52.384C34.532 53.2587 33.958 54.3247 33.466 55.582C33.0287 56.7847 32.646 58.0693 32.318 59.436ZM38.714 33.606C38.4407 34.9727 38.304 36.0387 38.304 36.804C38.304 38.4987 38.6867 39.756 39.452 40.576C40.2173 41.3413 41.3107 41.724 42.732 41.724C43.6067 41.724 44.5087 41.5053 45.438 41.068C46.3673 40.6307 47.2147 39.9473 47.98 39.018C48.7453 38.0887 49.3467 36.9133 49.784 35.492C50.276 34.0707 50.522 32.4033 50.522 30.49C50.522 27.2647 49.046 25.652 46.094 25.652C42.2127 25.652 39.7527 28.3033 38.714 33.606ZM20.51 59.6C21.2753 55.9373 22.724 52.794 24.856 50.17C27.0427 47.546 29.858 45.906 33.302 45.25L33.384 45.086C32.1813 44.758 31.17 44.3207 30.35 43.774C29.53 43.1727 28.874 42.4893 28.382 41.724C27.89 40.9587 27.5347 40.1387 27.316 39.264C27.0973 38.3893 26.988 37.4873 26.988 36.558C26.988 36.1207 27.0153 35.6833 27.07 35.246C27.1247 34.8087 27.2067 34.3713 27.316 33.934C28.5187 28.2487 30.8967 24.176 34.45 21.716C38.0033 19.2013 42.4313 17.944 47.734 17.944C52.2167 17.944 55.7153 18.8187 58.23 20.568C60.7447 22.3173 62.002 25.16 62.002 29.096C62.002 30.08 61.8653 31.3647 61.592 32.95C61.3733 34.5353 60.854 36.148 60.034 37.788C59.2687 39.3733 58.148 40.8493 56.672 42.216C55.196 43.5827 53.228 44.5393 50.768 45.086L50.686 45.25C53.2007 45.7967 55.0593 46.9447 56.262 48.694C57.4647 50.4433 58.066 52.63 58.066 55.254C58.066 55.9647 57.984 57.0033 57.82 58.37C57.656 59.682 57.3007 61.158 56.754 62.798C56.2073 64.438 55.442 66.1053 54.458 67.8C53.474 69.4947 52.1347 71.0527 50.44 72.474C48.7453 73.8407 46.668 74.9613 44.208 75.836C41.8027 76.7107 38.878 77.148 35.434 77.148C32.2633 77.148 29.6667 76.7653 27.644 76C25.676 75.2347 24.118 74.2507 22.97 73.048C21.822 71.8453 21.0293 70.506 20.592 69.03C20.2093 67.4993 20.018 65.9687 20.018 64.438C20.018 62.6887 20.182 61.076 20.51 59.6Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_379",
        x: "-4",
        y: "0.94397",
        width: "86.002",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_379"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_379",
          result: "effect2_dropShadow_1_379"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_379",
          result: "effect3_dropShadow_1_379"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_379",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_379",
        x: "16.0181",
        y: "17.944",
        width: "49.9839",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_379"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_379",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank8.defaultProps = {
  width: "82",
  height: "103",
  viewBox: "0 0 82 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank9 = function Rank9(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_381)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_381)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M36.992 37.132C36.5 39.3733 36.254 41.232 36.254 42.708C36.254 44.6213 36.6367 46.0153 37.402 46.89C38.222 47.71 39.452 48.12 41.092 48.12C43.4427 48.12 45.274 47.2727 46.586 45.578C47.9527 43.8833 49.046 41.068 49.866 37.132C50.358 34.9453 50.604 32.95 50.604 31.146C50.604 29.4513 50.2487 28.112 49.538 27.128C48.882 26.144 47.6247 25.652 45.766 25.652C44.3447 25.652 43.142 25.9527 42.158 26.554C41.2287 27.1007 40.436 27.8933 39.78 28.932C39.124 29.9707 38.5773 31.2007 38.14 32.622C37.7027 33.9887 37.32 35.492 36.992 37.132ZM32.646 62.47C32.4273 63.3993 32.318 64.3287 32.318 65.258C32.318 66.6247 32.6187 67.6633 33.22 68.374C33.876 69.0847 34.9693 69.44 36.5 69.44C38.0307 69.44 39.3427 69.0847 40.436 68.374C41.584 67.6087 42.5407 66.57 43.306 65.258C44.126 63.946 44.8093 62.388 45.356 60.584C45.9027 58.78 46.3947 56.812 46.832 54.68L47.406 51.892H47.242C45.93 53.368 44.2627 54.5707 42.24 55.5C40.2173 56.3747 37.894 56.812 35.27 56.812C31.2793 56.812 28.4093 55.7733 26.66 53.696C24.9653 51.564 24.118 48.7487 24.118 45.25C24.118 43.282 24.364 41.0953 24.856 38.69C26.2773 31.966 28.8467 26.8273 32.564 23.274C36.2813 19.7207 41.42 17.944 47.98 17.944C50.768 17.944 53.064 18.2993 54.868 19.01C56.7267 19.7207 58.2027 20.732 59.296 22.044C60.3893 23.3013 61.1547 24.8047 61.592 26.554C62.0293 28.3033 62.248 30.2167 62.248 32.294C62.248 34.2073 62.084 36.2573 61.756 38.444C61.428 40.576 61.0453 42.79 60.608 45.086C59.7333 49.186 58.7767 53.1767 57.738 57.058C56.6993 60.8847 55.2507 64.3013 53.392 67.308C51.5333 70.26 49.1007 72.638 46.094 74.442C43.142 76.246 39.2607 77.148 34.45 77.148C32.646 77.148 30.924 76.9567 29.284 76.574C27.644 76.246 26.1953 75.672 24.938 74.852C23.7353 73.9773 22.7513 72.8567 21.986 71.49C21.2753 70.0687 20.92 68.3467 20.92 66.324C20.92 65.7227 20.9473 65.1213 21.002 64.52C21.0567 63.864 21.166 63.1807 21.33 62.47H32.646Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_381",
        x: "-4",
        y: "0.94397",
        width: "86.248",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_381"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_381",
          result: "effect2_dropShadow_1_381"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_381",
          result: "effect3_dropShadow_1_381"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_381",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_381",
        x: "16.9199",
        y: "17.944",
        width: "49.3281",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_381"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_381",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank9.defaultProps = {
  width: "83",
  height: "103",
  viewBox: "0 0 83 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank10 = function Rank10(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_383)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_383)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76L32.37 35H20.808L22.448 27.292H23.514C27.45 27.292 30.7027 26.554 33.272 25.078C35.896 23.602 37.8367 21.224 39.094 17.944H47.786L35.732 76H23.924ZM50.5304 48.94C51.3504 44.9493 52.2798 41.0953 53.3184 37.378C54.4118 33.606 55.8604 30.2987 57.6644 27.456C59.4684 24.5587 61.7644 22.2627 64.5524 20.568C67.3404 18.8187 70.8938 17.944 75.2124 17.944C80.2418 17.944 83.8498 19.01 86.0364 21.142C88.2778 23.2193 89.3984 26.6633 89.3984 31.474C89.3984 33.442 89.2344 35.656 88.9064 38.116C88.5784 40.5213 88.1138 43.2 87.5124 46.152C86.6924 50.1973 85.7631 54.0787 84.7244 57.796C83.6858 61.5133 82.2644 64.8207 80.4604 67.718C78.6564 70.5607 76.3604 72.8567 73.5724 74.606C70.7844 76.3007 67.2311 77.148 62.9124 77.148C57.8831 77.148 54.2478 76.082 52.0064 73.95C49.7651 71.818 48.6444 68.292 48.6444 63.372C48.6444 61.4587 48.8084 59.3267 49.1364 56.976C49.4644 54.5707 49.9291 51.892 50.5304 48.94ZM61.8464 51.482C60.6438 57.1673 60.0424 61.3767 60.0424 64.11C60.0424 66.1873 60.3978 67.6087 61.1084 68.374C61.8191 69.0847 62.9398 69.44 64.4704 69.44C65.7824 69.44 66.9031 69.1393 67.8324 68.538C68.8164 67.882 69.6911 66.816 70.4564 65.34C71.2764 63.8093 72.0418 61.7867 72.7524 59.272C73.4631 56.7573 74.2011 53.6413 74.9664 49.924L76.2784 43.61C77.4811 37.9247 78.0824 33.7427 78.0824 31.064C78.0824 28.9867 77.6998 27.5653 76.9344 26.8C76.2238 26.0347 75.1031 25.652 73.5724 25.652C72.2604 25.652 71.1124 25.98 70.1284 26.636C69.1991 27.2373 68.3518 28.3033 67.5864 29.834C66.8211 31.31 66.0831 33.3053 65.3724 35.82C64.6618 38.3347 63.9238 41.4507 63.1584 45.168L61.8464 51.482Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_383",
        x: "-11",
        y: "0.94397",
        width: "120.398",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_383"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_383",
          result: "effect2_dropShadow_1_383"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_383",
          result: "effect3_dropShadow_1_383"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_383",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_383",
        x: "16.8081",
        y: "17.944",
        width: "76.5903",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_383"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_383",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank10.defaultProps = {
  width: "110",
  height: "103",
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank11 = function Rank11(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_385)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_385)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM58.4024 76H70.2104L82.2644 17.944H73.5724C72.2604 21.224 70.3744 23.602 67.7504 25.078C65.1264 26.554 61.9284 27.292 57.9924 27.292H56.9264L55.2864 35H66.8484L58.4024 76Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_385",
        x: "-11",
        y: "0.94397",
        width: "114",
        height: "100.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_385"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_385",
          result: "effect2_dropShadow_1_385"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_385",
          result: "effect3_dropShadow_1_385"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_385",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_385",
        x: "16.8081",
        y: "17.944",
        width: "69.4563",
        height: "66.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_385"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_385",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank11.defaultProps = {
  width: "103",
  height: "101",
  viewBox: "0 0 103 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank12 = function Rank12(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_387)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_387)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM80.7064 76L82.5924 66.816H60.6984C61.1904 65.75 62.0104 64.438 63.3224 62.962C64.6344 61.486 66.2744 59.928 68.4064 58.288L76.2784 52.22C78.4104 50.58 80.3784 48.858 82.0184 47.136C83.6584 45.496 85.1344 43.692 86.2824 41.806C87.4304 40.002 88.2504 38.034 88.8244 35.984C89.3164 33.934 89.6444 31.72 89.6444 29.26C89.6444 25.652 88.4144 22.864 86.0364 20.896C83.6584 18.928 79.9684 17.944 75.0484 17.944C68.6524 17.944 63.8144 19.42 60.3704 22.29C56.9264 25.242 54.6304 29.342 53.4824 34.754L52.9904 36.968H64.3064C64.6344 35.492 64.9624 34.016 65.4544 32.622C65.8644 31.31 66.4384 30.08 67.0944 29.014C67.7504 28.03 68.5704 27.21 69.5544 26.554C70.5384 25.98 71.7684 25.652 73.2444 25.652C76.2784 25.652 77.8364 27.21 77.8364 30.162C77.8364 30.654 77.7544 31.064 77.7544 31.474C77.6724 31.966 77.5904 32.376 77.5084 32.868C77.1804 34.426 76.7704 35.738 76.4424 36.886C76.0324 38.034 75.5404 39.018 74.8844 40.002C74.2284 40.986 73.4084 41.97 72.4244 42.954C71.4404 43.938 70.1284 45.004 68.6524 46.152L62.9944 50.58C60.3704 52.548 58.0744 54.516 56.1064 56.484C54.1384 58.452 52.4164 60.42 50.9404 62.388C49.4644 64.438 48.2344 66.57 47.2504 68.784C46.2664 70.998 45.4464 73.376 44.9544 76H80.7064Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_387",
        x: "-11",
        y: "0.94397",
        width: "120.645",
        height: "100.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_387"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_387",
          result: "effect2_dropShadow_1_387"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_387",
          result: "effect3_dropShadow_1_387"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_387",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_387",
        x: "16.8081",
        y: "17.944",
        width: "76.8364",
        height: "66.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_387"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_387",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank12.defaultProps = {
  width: "110",
  height: "101",
  viewBox: "0 0 110 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank13 = function Rank13(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_389)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_389)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM59.9604 59.026H48.6444L48.5624 59.272C48.0704 61.404 47.9064 63.208 47.9064 64.766C47.9064 68.702 48.9724 71.818 51.2684 73.95C53.5644 76.082 57.0084 77.148 61.6824 77.148C66.4384 77.148 70.2924 76.41 73.3264 74.852C76.3604 73.294 78.7384 71.408 80.4604 69.112C82.1824 66.898 83.4124 64.52 84.0684 61.896C84.7244 59.354 85.0524 57.058 85.0524 55.09C85.0524 52.63 84.3964 50.662 83.1664 49.022C81.9364 47.382 79.8864 46.316 77.0984 45.824V45.66C78.7384 45.332 80.2964 44.758 81.7724 43.774C83.2484 42.79 84.4784 41.642 85.5444 40.166C86.6104 38.69 87.4304 37.05 88.0864 35.082C88.7424 33.196 89.0704 31.064 89.0704 28.768C89.0704 25.078 87.8404 22.372 85.4624 20.568C83.0024 18.846 79.5584 17.944 75.0484 17.944C69.3904 17.944 64.7984 19.42 61.3544 22.208C57.9104 24.996 55.5324 29.342 54.3844 35.082H65.2084C65.4544 33.77 65.7824 32.458 66.1924 31.31C66.5204 30.162 67.0124 29.178 67.6684 28.358C68.3244 27.538 69.0624 26.882 69.9644 26.39C70.7844 25.898 71.8504 25.652 73.1624 25.652C74.6384 25.652 75.7044 25.98 76.5244 26.636C77.2624 27.292 77.6724 28.44 77.6724 29.998C77.6724 31.474 77.4264 32.868 77.0984 34.344C76.6884 35.82 76.1144 37.132 75.3764 38.362C74.5564 39.592 73.6544 40.576 72.5064 41.314C71.3584 42.134 70.1284 42.462 68.6524 42.462H64.7984L63.1584 50.17H67.0944C69.3904 50.17 71.0304 50.744 71.8504 51.81C72.6704 52.958 73.1624 54.352 73.1624 55.992C73.1624 57.632 72.9984 59.272 72.6704 60.83C72.3424 62.47 71.7684 63.864 71.1124 65.176C70.4564 66.488 69.5544 67.472 68.4064 68.292C67.2584 69.112 65.8644 69.44 64.2244 69.44C62.4204 69.44 61.1084 69.03 60.3704 68.21C59.6324 67.39 59.3044 66.078 59.3044 64.274C59.3044 62.962 59.4684 61.24 59.9604 59.026Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_389",
        x: "-11",
        y: "0.94397",
        width: "120.071",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_389"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_389",
          result: "effect2_dropShadow_1_389"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_389",
          result: "effect3_dropShadow_1_389"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_389",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_389",
        x: "16.8081",
        y: "17.944",
        width: "76.2625",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_389"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_389",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank13.defaultProps = {
  width: "110",
  height: "103",
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank14 = function Rank14(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_391)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_391)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM49.1364 54.27L47.0864 63.946H67.7504L65.2904 76H76.1144L78.5744 63.946H84.1504L86.0364 54.762H80.4604L88.1684 17.944H75.9504L49.1364 54.27ZM74.2284 32.704L69.6364 54.762H58.1564L74.0644 32.704H74.2284Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_391",
        x: "-11",
        y: "0.94397",
        width: "119.168",
        height: "100.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_391"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_391",
          result: "effect2_dropShadow_1_391"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_391",
          result: "effect3_dropShadow_1_391"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_391",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_391",
        x: "16.8081",
        y: "17.944",
        width: "75.3604",
        height: "66.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_391"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_391",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank14.defaultProps = {
  width: "109",
  height: "101",
  viewBox: "0 0 109 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank15 = function Rank15(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_393)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_393)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM88.2504 28.276L90.1364 19.092H59.8784L51.1864 50.662H61.7644C62.2564 49.022 63.0764 47.792 64.2244 46.808C65.2904 45.824 66.6844 45.332 68.4064 45.332C70.2104 45.332 71.5224 45.742 72.3424 46.48C73.1624 47.3 73.5724 48.612 73.5724 50.58C73.5724 51.482 73.4904 52.548 73.3264 53.696C73.1624 54.844 72.9164 56.156 72.6704 57.632C71.8504 61.404 70.7844 64.274 69.3084 66.16C67.8324 68.046 65.8644 68.948 63.4044 68.948C61.6824 68.948 60.5344 68.456 59.9604 67.39C59.3864 66.406 59.1404 65.176 59.1404 63.7C59.1404 62.962 59.1404 62.224 59.3044 61.486C59.3864 60.83 59.4684 60.092 59.6324 59.436H48.3164L48.0704 60.994C47.9064 61.814 47.8244 62.716 47.6604 63.618C47.4964 64.52 47.4964 65.422 47.5784 66.324C47.5784 67.718 47.7424 69.03 48.2344 70.342C48.7264 71.654 49.4644 72.802 50.6124 73.786C51.6784 74.77 53.1544 75.59 54.9584 76.246C56.7624 76.902 59.0584 77.148 61.8464 77.148C65.5364 77.148 68.7344 76.656 71.3584 75.59C73.9824 74.606 76.1144 73.13 77.9184 71.244C79.7224 69.358 81.1164 67.062 82.2644 64.438C83.3304 61.814 84.2324 58.944 84.8884 55.664C85.3804 53.368 85.6264 51.154 85.6264 48.94C85.6264 47.3 85.3804 45.824 85.0524 44.348C84.6424 42.954 83.9864 41.724 83.1664 40.658C82.3464 39.592 81.1984 38.772 79.8044 38.116C78.3284 37.46 76.6064 37.132 74.5564 37.132C72.0144 37.132 69.8004 37.542 67.9144 38.198C66.0284 38.854 64.3884 40.002 62.9944 41.478H62.8304L66.8484 28.276H88.2504Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_393",
        x: "-11",
        y: "0.94397",
        width: "121.136",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_393"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_393",
          result: "effect2_dropShadow_1_393"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_393",
          result: "effect3_dropShadow_1_393"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_393",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_393",
        x: "16.808",
        y: "17.944",
        width: "77.3285",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_393"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_393",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank15.defaultProps = {
  width: "111",
  height: "103",
  viewBox: "0 0 111 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank16 = function Rank16(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_395)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_395)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM60.6984 57.96C61.5184 54.024 62.5844 51.236 63.8964 49.514C65.2084 47.874 67.0944 46.972 69.4724 46.972C71.1124 46.972 72.2604 47.464 73.0804 48.284C73.9004 49.104 74.3104 50.498 74.3104 52.384C74.3104 53.204 74.2284 54.024 74.0644 54.926C73.9004 55.91 73.7364 56.894 73.5724 57.96C73.2444 59.6 72.8344 61.158 72.4244 62.552C72.0144 63.946 71.5224 65.176 70.8664 66.16C70.2104 67.226 69.3904 68.046 68.4064 68.62C67.4224 69.194 66.1924 69.44 64.7984 69.44C62.9124 69.44 61.6004 68.948 60.9444 67.964C60.2884 66.98 59.9604 65.668 59.9604 64.028C59.9604 62.306 60.2064 60.256 60.6984 57.96ZM77.9184 32.704H89.2344C89.4804 31.228 89.6444 29.916 89.6444 28.768C89.6444 26.8 89.2344 25.078 88.5784 23.684C87.8404 22.372 86.8564 21.224 85.6264 20.404C84.3964 19.584 83.0024 18.928 81.3624 18.518C79.7224 18.19 78.0004 17.944 76.1964 17.944C71.3584 17.944 67.4224 18.846 64.4704 20.65C61.4364 22.454 58.9764 24.914 57.1724 27.866C55.2864 30.818 53.8104 34.262 52.8264 38.116C51.7604 41.97 50.7764 45.906 49.9564 50.006C49.4644 52.302 49.0544 54.434 48.7264 56.566C48.3984 58.698 48.3164 60.748 48.3164 62.634C48.3164 64.766 48.4804 66.652 48.9724 68.456C49.4644 70.26 50.2024 71.736 51.3504 73.048C52.4164 74.36 53.8924 75.344 55.6964 76.082C57.5004 76.82 59.8784 77.148 62.6664 77.148C69.2264 77.148 74.3924 75.426 78.0824 71.9C81.7724 68.374 84.3144 63.208 85.7084 56.402C86.2004 54.106 86.4464 51.974 86.4464 49.842C86.4464 46.398 85.5444 43.61 83.8224 41.478C82.1004 39.346 79.2304 38.28 75.2944 38.28C72.6704 38.28 70.2924 38.772 68.3244 39.674C66.2744 40.576 64.6344 41.806 63.3224 43.282H63.1584L63.8144 40.412C64.2244 38.28 64.7164 36.312 65.2904 34.508C65.7824 32.704 66.4384 31.146 67.2584 29.834C67.9964 28.522 68.8984 27.538 70.0464 26.8C71.1124 26.062 72.4244 25.652 74.0644 25.652C75.5404 25.652 76.6064 26.062 77.2624 26.718C77.9184 27.374 78.2464 28.44 78.2464 29.752C78.2464 30.244 78.1644 30.654 78.1644 31.146C78.0824 31.638 78.0004 32.212 77.9184 32.704Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_395",
        x: "-11",
        y: "0.94397",
        width: "120.644",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_395"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_395",
          result: "effect2_dropShadow_1_395"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_395",
          result: "effect3_dropShadow_1_395"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_395",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_395",
        x: "16.808",
        y: "17.944",
        width: "76.8364",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_395"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_395",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank16.defaultProps = {
  width: "110",
  height: "103",
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank17 = function Rank17(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_397)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_397)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM92.8424 19.092H57.0904L54.9584 29.26H79.3944C75.7864 33.196 72.5064 37.132 69.5544 41.15C66.6024 45.168 64.0604 49.186 61.7644 53.204C59.4684 57.222 57.4184 61.158 55.7784 65.012C54.1384 68.866 52.7444 72.556 51.5964 76H63.9784C65.2904 71.9 66.8484 67.8 68.6524 63.536C70.4564 59.272 72.4244 55.09 74.7204 50.99C77.0164 46.89 79.4764 42.954 82.1824 39.018C84.8884 35.164 87.8404 31.556 90.9564 28.112L92.8424 19.092Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_397",
        x: "-11",
        y: "0.94397",
        width: "123.842",
        height: "100.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_397"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_397",
          result: "effect2_dropShadow_1_397"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_397",
          result: "effect3_dropShadow_1_397"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_397",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_397",
        x: "16.808",
        y: "17.944",
        width: "80.0344",
        height: "66.056",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_397"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_397",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank17.defaultProps = {
  width: "113",
  height: "101",
  viewBox: "0 0 113 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank18 = function Rank18(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_399)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_399)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM59.7964 59.436C60.1244 58.124 60.4524 56.812 60.9444 55.582C61.4364 54.352 62.0104 53.286 62.6664 52.384C63.3224 51.482 64.1424 50.744 65.1264 50.252C66.1104 49.76 67.2584 49.432 68.6524 49.432C70.5384 49.432 71.8504 50.006 72.6704 50.99C73.4084 52.056 73.8184 53.45 73.8184 55.09C73.8184 56.894 73.5724 58.698 73.1624 60.42C72.7524 62.142 72.1784 63.7 71.4404 65.012C70.6204 66.324 69.6364 67.39 68.4884 68.21C67.3404 69.03 65.9464 69.44 64.4704 69.44C62.5024 69.44 61.1904 68.948 60.4524 67.882C59.6324 66.898 59.3044 65.504 59.3044 63.7C59.3044 62.47 59.4684 61.076 59.7964 59.436ZM66.1924 33.606C67.1764 28.358 69.6364 25.652 73.5724 25.652C76.5244 25.652 78.0004 27.292 78.0004 30.49C78.0004 32.458 77.7544 34.098 77.2624 35.492C76.7704 36.968 76.1964 38.116 75.4584 39.018C74.6384 40.002 73.8184 40.658 72.9164 41.068C71.9324 41.56 71.0304 41.724 70.2104 41.724C68.7344 41.724 67.6684 41.396 66.9304 40.576C66.1104 39.756 65.7824 38.526 65.7824 36.804C65.7824 36.066 65.8644 35 66.1924 33.606ZM47.9884 59.6C47.6604 61.076 47.4964 62.716 47.4964 64.438C47.4964 65.996 47.6604 67.554 48.0704 69.03C48.4804 70.506 49.3004 71.9 50.4484 73.048C51.5964 74.278 53.1544 75.262 55.1224 76C57.0904 76.82 59.7144 77.148 62.9124 77.148C66.3564 77.148 69.2264 76.738 71.6864 75.836C74.1464 75.016 76.1964 73.868 77.9184 72.474C79.5584 71.08 80.9524 69.522 81.9364 67.8C82.9204 66.16 83.6584 64.438 84.2324 62.798C84.7244 61.158 85.1344 59.682 85.2984 58.37C85.4624 57.058 85.5444 55.992 85.5444 55.254C85.5444 52.63 84.8884 50.498 83.7404 48.694C82.5104 46.972 80.6244 45.824 78.1644 45.25L78.2464 45.086C80.7064 44.594 82.6744 43.61 84.1504 42.216C85.6264 40.904 86.6924 39.428 87.5124 37.788C88.3324 36.148 88.8244 34.59 89.0704 32.95C89.3164 31.392 89.4804 30.08 89.4804 29.096C89.4804 25.16 88.1684 22.372 85.7084 20.568C83.1664 18.846 79.6404 17.944 75.2124 17.944C69.8824 17.944 65.4544 19.256 61.9284 21.716C58.3204 24.176 55.9424 28.276 54.7944 33.934C54.6304 34.426 54.5484 34.836 54.5484 35.246C54.4664 35.738 54.4664 36.148 54.4664 36.558C54.4664 37.542 54.5484 38.444 54.7944 39.264C54.9584 40.166 55.3684 40.986 55.8604 41.724C56.3524 42.544 57.0084 43.2 57.8284 43.774C58.6484 44.348 59.6324 44.758 60.8624 45.086L60.7804 45.25C57.3364 45.906 54.4664 47.546 52.3344 50.17C50.2024 52.794 48.7264 55.992 47.9884 59.6Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_399",
        x: "-11",
        y: "0.94397",
        width: "120.48",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_399"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_399",
          result: "effect2_dropShadow_1_399"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_399",
          result: "effect3_dropShadow_1_399"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_399",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_399",
        x: "16.808",
        y: "17.944",
        width: "76.6725",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_399"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_399",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank18.defaultProps = {
  width: "110",
  height: "103",
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank19 = function Rank19(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_401)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_401)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM64.4704 37.132C64.7984 35.492 65.1264 34.016 65.6184 32.622C66.0284 31.228 66.6024 29.998 67.2584 28.932C67.9144 27.948 68.6524 27.128 69.6364 26.554C70.6204 25.98 71.7684 25.652 73.2444 25.652C75.0484 25.652 76.3604 26.144 77.0164 27.128C77.6724 28.112 78.0824 29.506 78.0824 31.146C78.0824 32.95 77.8364 35 77.3444 37.132C76.5244 41.068 75.3764 43.938 74.0644 45.578C72.7524 47.3 70.8664 48.12 68.5704 48.12C66.9304 48.12 65.7004 47.71 64.8804 46.89C64.0604 46.07 63.7324 44.676 63.7324 42.708C63.7324 41.232 63.9784 39.428 64.4704 37.132ZM60.1244 62.47H48.8084C48.6444 63.208 48.4804 63.864 48.4804 64.52C48.3984 65.176 48.3984 65.75 48.3984 66.324C48.3984 68.374 48.7264 70.096 49.4644 71.49C50.2024 72.884 51.1864 74.032 52.4164 74.852C53.6464 75.672 55.1224 76.328 56.7624 76.656C58.4024 76.984 60.1244 77.148 61.9284 77.148C66.6844 77.148 70.6204 76.246 73.5724 74.442C76.5244 72.638 78.9844 70.26 80.8704 67.308C82.6744 64.356 84.1504 60.912 85.2164 57.058C86.2004 53.204 87.1844 49.186 88.0864 45.086C88.4964 42.79 88.9064 40.576 89.2344 38.444C89.5624 36.312 89.7264 34.262 89.7264 32.294C89.7264 30.244 89.4804 28.358 89.0704 26.554C88.5784 24.832 87.8404 23.356 86.7744 22.044C85.6264 20.732 84.1504 19.748 82.3464 19.01C80.5424 18.354 78.2464 17.944 75.4584 17.944C68.8984 17.944 63.7324 19.748 60.0424 23.274C56.2704 26.882 53.7284 31.966 52.3344 38.69C51.8424 41.15 51.5964 43.282 51.5964 45.25C51.5964 48.776 52.4164 51.564 54.1384 53.696C55.8604 55.828 58.7304 56.812 62.7484 56.812C65.3724 56.812 67.6684 56.402 69.7184 55.5C71.6864 54.598 73.4084 53.368 74.7204 51.892H74.8844L74.3104 54.68C73.8184 56.812 73.3264 58.78 72.8344 60.584C72.2604 62.388 71.6044 63.946 70.7844 65.258C69.9644 66.57 69.0624 67.636 67.9144 68.374C66.7664 69.112 65.4544 69.44 63.9784 69.44C62.4204 69.44 61.3544 69.112 60.6984 68.374C60.0424 67.718 59.7964 66.652 59.7964 65.258C59.7964 64.356 59.8784 63.454 60.1244 62.47Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_401",
        x: "-11",
        y: "0.94397",
        width: "120.726",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_401"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_401",
          result: "effect2_dropShadow_1_401"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_401",
          result: "effect3_dropShadow_1_401"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_401",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_401",
        x: "16.808",
        y: "17.944",
        width: "76.9185",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_401"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_401",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank19.defaultProps = {
  width: "110",
  height: "103",
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Rank20 = function Rank20(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      filter: "url(#filter0_ddd_1_403)",
      children: /*#__PURE__*/_jsx("g", {
        filter: "url(#filter1_d_1_403)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M56.228 76L58.114 66.816H36.22C36.712 65.75 37.532 64.438 38.844 62.962C40.156 61.486 41.796 59.928 43.928 58.288L51.8 52.22C53.932 50.58 55.9 48.858 57.54 47.136C59.18 45.496 60.656 43.692 61.804 41.806C62.952 40.002 63.772 38.034 64.346 35.984C64.838 33.934 65.166 31.72 65.166 29.26C65.166 25.652 63.936 22.864 61.558 20.896C59.18 18.928 55.49 17.944 50.57 17.944C44.174 17.944 39.336 19.42 35.892 22.29C32.448 25.242 30.152 29.342 29.004 34.754L28.512 36.968H39.828C40.156 35.492 40.484 34.016 40.976 32.622C41.386 31.31 41.96 30.08 42.616 29.014C43.272 28.03 44.092 27.21 45.076 26.554C46.06 25.98 47.29 25.652 48.766 25.652C51.8 25.652 53.358 27.21 53.358 30.162C53.358 30.654 53.276 31.064 53.276 31.474C53.194 31.966 53.112 32.376 53.03 32.868C52.702 34.426 52.292 35.738 51.964 36.886C51.554 38.034 51.062 39.018 50.406 40.002C49.75 40.986 48.93 41.97 47.946 42.954C46.962 43.938 45.65 45.004 44.174 46.152L38.516 50.58C35.892 52.548 33.596 54.516 31.628 56.484C29.66 58.452 27.938 60.42 26.462 62.388C24.986 64.438 23.756 66.57 22.772 68.784C21.788 70.998 20.968 73.376 20.476 76H56.228ZM65.4504 48.94C64.7944 51.892 64.3844 54.598 64.0564 56.976C63.7284 59.354 63.5644 61.486 63.5644 63.372C63.5644 68.292 64.6304 71.818 66.9264 73.95C69.1404 76.082 72.7484 77.148 77.8324 77.148C82.0964 77.148 85.7044 76.328 88.4924 74.606C91.2804 72.884 93.5764 70.588 95.3804 67.718C97.1844 64.848 98.5784 61.568 99.6444 57.796C100.628 54.106 101.612 50.252 102.432 46.152C103.006 43.2 103.498 40.576 103.826 38.116C104.154 35.656 104.318 33.442 104.318 31.474C104.318 26.718 103.17 23.274 100.956 21.142C98.7424 19.01 95.1344 17.944 90.1324 17.944C85.7864 17.944 82.2604 18.846 79.4724 20.568C76.6844 22.29 74.3884 24.586 72.5844 27.456C70.7804 30.326 69.3044 33.606 68.2384 37.378C67.1724 41.15 66.2704 45.004 65.4504 48.94ZM76.7664 51.482L78.0784 45.168C78.8164 41.478 79.5544 38.362 80.2924 35.82C80.9484 33.36 81.6864 31.31 82.5064 29.834C83.2444 28.358 84.0644 27.292 85.0484 26.636C86.0324 25.98 87.1804 25.652 88.4924 25.652C89.9684 25.652 91.1164 26.062 91.8544 26.8C92.5924 27.62 93.0024 29.014 93.0024 31.064C93.0024 33.77 92.3464 37.952 91.1984 43.61L89.8864 49.924C89.0664 53.696 88.3284 56.812 87.6724 59.272C86.9344 61.814 86.1964 63.864 85.3764 65.34C84.5564 66.816 83.7364 67.882 82.7524 68.538C81.7684 69.194 80.7024 69.44 79.3904 69.44C77.8324 69.44 76.6844 69.112 76.0284 68.374C75.2904 67.636 74.9624 66.242 74.9624 64.11C74.9624 61.404 75.5364 57.222 76.7664 51.482Z",
          fill: "#FAFAFA"
        })
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("filter", {
        id: "filter0_ddd_1_403",
        x: "-1",
        y: "0.94397",
        width: "125.318",
        height: "101.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "5"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "10"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_403"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "9"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_1_403",
          result: "effect2_dropShadow_1_403"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "6"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "effect2_dropShadow_1_403",
          result: "effect3_dropShadow_1_403"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect3_dropShadow_1_403",
          result: "shape"
        })]
      }), /*#__PURE__*/_jsxs("filter", {
        id: "filter1_d_1_403",
        x: "16.476",
        y: "17.944",
        width: "91.8425",
        height: "67.204",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "4"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "2"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1_403"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1_403",
          result: "shape"
        })]
      })]
    })]
  }));
};
Rank20.defaultProps = {
  width: "125",
  height: "103",
  viewBox: "0 0 125 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import styles from "@/styles/RankingPalette.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const rankImages = {
  1: Rank1,
  2: Rank2,
  3: Rank3,
  4: Rank4,
  5: Rank5,
  6: Rank6,
  7: Rank7,
  8: Rank8,
  9: Rank9,
  10: Rank10,
  11: Rank11,
  12: Rank12,
  13: Rank13,
  14: Rank14,
  15: Rank15,
  16: Rank16,
  17: Rank17,
  18: Rank18,
  19: Rank19,
  20: Rank20
};
const RankImage = _ref => {
  let {
    rank
  } = _ref;
  const RankComponent = rankImages[rank] || null;
  if (!RankComponent) {
    return null;
  }
  return /*#__PURE__*/_jsx(RankComponent, {
    className: styles.rankImage
  });
};
export default RankImage;